// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3PRt1EaST3ObCZf9ALeOJL","table-wrapper":"pexyJZJIwCQnJgeJZmXvk","header_panel":"_1iWEFyxOt9ImNfR9nRDtrQ","thickTitle":"_391YStaquskiFgEgkD8lCN"};